// TODO: monograph-svc still defines its own identical `DressingMode`
// (apps/monograph-svc/src/app/modules/order/dto/line-item.dto.ts). Update it to import this
// shared enum so there's a single source of truth across services.
export enum DressingMode {
  NOT_DRESSABLE = 'NOT_DRESSABLE',
  REMOVED = 'REMOVED',
  MIXED = 'MIXED',
  ON_THE_SIDE = 'ON_THE_SIDE',
}
